// extracted by mini-css-extract-plugin
export default {"card":"modal_card__PXV7b","upgradeModal":"modal_upgradeModal__DXv-L","modal-backdrop":"modal_modal-backdrop__R6Hnj"};